import moment from 'moment'

let fs: any = null

let path: any = null
if (!process.server) {
  try {
    fs = window.require ? window.require('fs') : null
    path = window.require ? window.require('path') : null
  } catch (e) {

  }

}


let currentWriteStream = null;
let currentFileName = null;
const maxFileSize = 5 * 1024 * 1024; // 5 MB

// 创建写入流
function createWriteStream(fileName) {
  if (process.server)  return ;
  const logDir = path.resolve(window.process.cwd(), './', 'log');
  if (!fs.existsSync(logDir)) {
    fs.mkdirSync(logDir);
  }
  const fullWriteFilePath = path.resolve(logDir, fileName);
  const writeStream = fs.createWriteStream(fullWriteFilePath, {
    flags: 'a' // 以追加模式打开文件
  });
  return { writeStream, fullWriteFilePath };
}

// 写日志
function writeLog(log) {
  if (process.server)  return ;
  if (currentWriteStream) {
    const logMessage = `[${moment().format('YYYY-MM-DD HH:mm:ss.SSS')}][INFO] ${log}\n`;
    currentWriteStream.write(logMessage);

    // 检查文件大小
    const stats = fs.statSync(path.resolve(window.process.cwd(), './', 'log', currentFileName));
    if (stats.size >= maxFileSize) {
      // 结束当前写入流
      currentWriteStream.end();

      // 创建新的写入流
      currentFileName = moment().format('YYYY-MM-DD_HH-mm-ss') + '_' + Math.random().toString(36).substring(7) + '.log';
      currentWriteStream = createWriteStream(currentFileName).writeStream;
    }
  }
}

// 初始化日志系统
export function initLogger() {
  if (process.server)  return ;
  if (!window.require) {
    return
  }
  const logDir = path.resolve(window.process.cwd(), './', 'log');
  if (!fs.existsSync(logDir)) {
    fs.mkdirSync(logDir);
  }
  // 查找最新的日志文件
  const files = fs.readdirSync(logDir).filter(file => file.endsWith('.log'));
  if (files.length > 0) {
    // 获取最新的日志文件
    currentFileName = files.sort().pop(); // 按名称排序，最新的文件在最后
  } else {
    // 如果没有日志文件，则使用当前日期作为文件名
    currentFileName = moment().format('YYYY-MM-DD') + '.log';
  }

  currentWriteStream = createWriteStream(currentFileName).writeStream;

}

// 日志记录函数
export function nwAppLog(content: string): void {
  if (process.server)  return ;
  if (window.require) {
    try {
      writeLog(content);
    } catch (e) {
      console.log(e)
    }

  } else {
    console.log(`[${moment().format('YYYY-MM-DD HH:mm:ss.SSS')}][INFO] ${content}`);
  }
}
if (!process.server){
window['nwAppLog'] = nwAppLog;
// 在应用启动时初始化
try {
  initLogger();
} catch (e) {
  console.log(e)
}

}


